import exportSettings from './reducers';

export default exportSettings;
